import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BlogPost } from "../services/firebase";
import HeroPhoto from "../assets/image/heroPhoto.png";
import "./BlogCard.css";
import PrimaryButton from "./PrimaryButton";

interface BlogCardProps {
  post: BlogPost;
  inView?: boolean;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, inView = true }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Get current language
  const currentLanguage = i18n.language;

  // Get localized content based on current language
  const getLocalizedTitle = () => {
    if (currentLanguage === "ru" && post.titleRu) {
      return post.titleRu;
    }
    return post.title;
  };

  const handleCardClick = () => {
    navigate(`/blog/${post.id}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  //אני רוצה להכניס לפה את הזמן שהפוסט נרשם את התאריך ואת השעה
  const time = post.publishedAt
    ? new Date(
        post.publishedAt.toDate ? post.publishedAt.toDate() : post.publishedAt
      )
        .toLocaleString("he-IL", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(",", " |")
    : post.createdAt
    ? new Date(post.createdAt.toDate ? post.createdAt.toDate() : post.createdAt)
        .toLocaleString("he-IL", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(",", " |")
    : "";

  return (
    <div
      className={`blog-card${inView ? "" : " inactive"}`}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${getLocalizedTitle()} - ${t("readNow") || "קרא עכשיו"}`}
      data-language={i18n.language}
    >
      <div className="blog-card-image">
        <img
          src={
            post.imageUrl &&
            post.imageUrl !== "" &&
            post.imageUrl !== "safa" &&
            post.imageUrl.startsWith("http")
              ? post.imageUrl
              : HeroPhoto
          }
          alt={post.title}
        />
      </div>
      <div className="blog-card-time">{time}</div>
      <div className="blog-card-content">
        <h3 className="blog-card-title">{getLocalizedTitle()}</h3>

        <PrimaryButton fullWidth={true} onClick={handleCardClick}>
          {t("readNow")}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default BlogCard;
